export default __webpack_public_path__ + "static/media/empty-voucher.4ae625bf.svg";